<template>
    <div
        id="be-miei-dati"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <loading-animation
                class="loading"
                v-show="loading"
            />
            <main v-show="!loading">
                <div class="container-fluid mt-5">
                    <div class="row d-flex justify-content-between flex-wrap align-items-center">
                        <div class="col-sm-8">
                            <h2 class="text-uppercase mb-0">{{$t('I miei dati')}}</h2>
                        </div>
                    </div>

                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form
                            id="shop-form"
                            ref="form"
                            class="mt-3"
                            enctype="multipart/form-data"
                            @submit.prevent="handleSubmit(onSubmit)"
                            v-if="!isAgent"
                        >
                            <fieldset>
                                <div class="form-row align-items-center">
                                    <div class="col-md-3 order-1">
                                        <img
                                            v-if="logoUrl"
                                            :src="logoUrl"
                                            alt="RikordaEventi"
                                            class="mw-100 mh-100"
                                        />
                                    </div>
                                    <input
                                        ref="logo"
                                        type="file"
                                        accept="image/png"
                                        name="logo"
                                        id="logo"
                                        class="col order-3 order-md-2 mt-2 mt-md-0"
                                        @change.prevent="uploadLogo()"
                                    />
                                    <div class="col-md-4 order-2 order-md-3 mt-2 mt-md-0">{{ $t('Invia il logo in formato PNG di dimensioni 150x40px') }}</div>
                                </div>
                                <div class="form-group mb-0 mt-3">
                                    <label for="ragione-sociale">{{$t('Ragione sociale')}}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="text"
                                            name="ragione-sociale"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="ragione-sociale"
                                            v-model="shop.ragioneSociale"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="form-row mb-0 mt-3">
                                    <div class="col-sm-6">
                                        <label for="email">{{$t('Email')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required|email|validEmail"
                                            v-slot="{ touched, valid, invalid, pending, errors, validate }"
                                            mode="passive"
                                            :debounce="5"
                                        >
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                v-model="shop.email"
                                                :class="{'form-control rounded-pill rilievo-ombra-interna': true, 'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                                @change="validate()"
                                            />
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mt-3 mt-sm-0">
                                        <label for="tel">{{$t('Telefono')}}</label>
                                        <input
                                            type="tel"
                                            name="tel"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="tel"
                                            v-model="shop.telefono"
                                        >
                                    </div>
                                </div>
                                <div class="form-row mb-0 mt-3">
                                    <div class="col-sm-6">
                                        <label for="facebook">{{$t('Facebook')}}</label>
                                        <input
                                            id="facebook"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            v-model="shop.facebook"
                                            type="url"
                                        />
                                    </div>
                                    <div class="col-sm-6 mt-3 mt-sm-0">
                                        <label for="instagram">{{$t('Instagram')}}</label>
                                        <input
                                            id="instagram"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            v-model="shop.instagram"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="form-group mb-0 mt-3">
                                    <label for="indirizzo">{{$t('Indirizzo')}} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="text"
                                            name="indirizzo"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="indirizzo"
                                            v-model="shop.indirizzo"
                                        >
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="form-check mt-1 pl-0">
                                    <input
                                        id="visualizza-indirizzo"
                                        class="mr-1"
                                        type="checkbox"
                                        v-model="shop.visualizzaIndirizzo"
                                        :checked="shop.visualizzaIndirizzo"
                                    />
                                    <label
                                        for="visualizza-indirizzo"
                                        class="mb-0"
                                    >
                                        {{$t('Visualizza indirizzo e mappa nella pagina contatti')}}</label>
                                </div>
                                <div class="form-row mb-0 mt-3">
                                    <div class="col-sm-4">
                                        <label for="provincia">{{$t('Provincia')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="provincia"
                                                id="provincia"
                                                ref="provincia"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.provincia"
                                                @change="onChangeProvince"
                                            >
                                                <option value="">{{$t('Seleziona provincia')}}</option>
                                                <option
                                                    v-for="province in provincesList"
                                                    v-bind:key="province.Sigla"
                                                    v-bind:value="province.Sigla"
                                                    v-bind:selected="province.Sigla === shop.provincia"
                                                >
                                                    {{province.Provincia}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-4 mt-3 mt-sm-0">
                                        <label for="citta">{{$t('Città')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="citta"
                                                id="citta"
                                                ref="citta"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                @change="onChangeCity"
                                                v-model="shop.citta"
                                            >
                                                <option value="">{{$t('Seleziona città')}}</option>
                                                <option
                                                    v-for="(key, value) in citiesList"
                                                    v-bind:key="value"
                                                    v-bind:value="value"
                                                    v-bind:selected="value === shop.citta"
                                                >
                                                    {{value}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-4 mt-3 mt-sm-0">
                                        <label for="cap">{{$t('CAP')}} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="cap"
                                                id="cap"
                                                ref="cap"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.cap"
                                            >
                                                <option value="">{{$t('Seleziona cap')}}</option>
                                                <option
                                                    v-for="zip in zipList"
                                                    v-bind:key="zip.cap"
                                                    v-bind:value="zip.cap"
                                                    v-bind:selected="zip.cap === shop.cap"
                                                >
                                                    {{zip.cap}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <google-map-loader
                                    v-if="isMapReady"
                                    v-bind:shop="shop"
                                />
                                <p class="text-center mb-0 mt-1">
                                    {{ $t("Se il punto visualizzato sulla mappa non corrisponde all'indirizzo che hai inserito, puoi spostare il marker nel punto esatto per correggere la posizione.") }}
                                </p>
                            </fieldset>
                            <div class="d-flex justify-content-end mt-3">
                                <button
                                    class="btn btn-primary btn-rikorda1"
                                    ref="save"
                                    type="submit"
                                >
                                    {{ $t("Salva") }}
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form
                            id="agent-form"
                            ref="form"
                            class="mt-3"
                            @submit.prevent="handleSubmit(onSubmit)"
                            v-if="isAgent"
                        >
                            <fieldset>
                                <div class="mb-0 mt-3">
                                    <label for="nome">{{$t('Nome')}}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="text"
                                            name="nome"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="nome"
                                            v-model="agent.Nome"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="mb-0 mt-3">
                                    <label for="cognome">{{$t('Cognome')}}
                                        <span class="text-danger">*</span>
                                    </label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="text"
                                            name="cognome"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="cognome"
                                            v-model="agent.Cognome"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="mb-0 mt-3">
                                    <label for="agent-email">{{$t('Email')}} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required|email"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="email"
                                            name="email"
                                            id="agent-email"
                                            v-model="agent.Email"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </fieldset>
                            <div class="d-flex justify-content-end mt-3">
                                <button
                                    class="btn btn-primary btn-rikorda1"
                                    ref="save"
                                    type="submit"
                                >
                                    {{ $t("Salva") }}
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </main>
            <backend-footer />
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";
import GoogleMapLoader from "../../components/GoogleMapLoader";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { email, required } from "vee-validate/dist/rules";
import LoadingAnimation from "../../components/LoadingAnimation";

export default {
    name: "BackendUserSettings",
    components: {
        LoadingAnimation,
        GoogleMapLoader,
        BackendFooter,
        BackendHeader,
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            shop: {},
            agent: {},
            isMapReady: false,
            logoUrl: "",
            loading: false,
            provincesList: [],
            citiesList: {},
            zipList: []
        };
    },
    methods: {
        onChangeProvince() {
            // disabilita gli elementi che dipendono dalla provincia
            this.$refs.provincia.disabled = true;
            this.$refs.citta.disabled = true;
            this.$refs.cap.disabled = true;
            //this.$refs.save.disabled = true;
            this.$api
                .backendGetItalyCities(this.shop.provincia)
                .then((result) => {
                    console.debug("GET_ITALY_CITIES", result);
                    this.citiesList = result.cities;
                    this.onChangeCity();
                    // riattiva gli elementi che dipendono dalla provincia
                    this.$refs.provincia.disabled = false;
                    this.$refs.citta.disabled = false;
                    this.$refs.cap.disabled = false;
                    //this.$refs.save.disabled = false;
                })
                .catch((error) => {
                    console.error("GET_ITALY_CITIES", error);
                });
        },

        onChangeCity() {
            if (this.citiesList[this.shop.citta]) {
                this.zipList = this.citiesList[this.shop.citta];
                if (
                    this.zipList.filter((zip) => {
                        return zip.cap === this.shop.cap;
                    }).length === 0
                ) {
                    this.shop.cap = "";
                }
            } else {
                this.zipList = [];
                this.shop.cap = "";
            }
        },

        onSubmit() {
            console.log("SALVATAGGIO DATI", this.shop);
            this.$api
                .backendUpdateUser(this.shop, this.agent, false)
                .then((result) => {
                    alert("Dati aggiornati");
                })
                .catch((error) => {
                    alert("ERRORE: " + error);
                });
        },

        uploadLogo() {
            const file = this.$refs.logo.files[0]; // <input type='file' />
            if (file) {
                const uri =
                    process.env.VUE_APP_API_BASE_URL +
                    process.env.VUE_APP_API_UPLOAD_PHOTO_ENDPOINT;
                const xhr = new XMLHttpRequest();
                const fd = new FormData();
                let that = this; // Vue
                xhr.open("POST", uri, true);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        console.debug("UPLOAD_LOGO_OK");
                        that.$refs.logo.value = "";
                        that.logoUrl = that.shop.urlGrafica
                            ? that.shop.urlGrafica + "?t=" + Date.now()
                            : "";
                    }
                };
                fd.append("file", file);
                fd.append("uploadType", "logo");
                fd.append("userId", this.shop.fkUtente);
                xhr.send(fd);
            }
        }
    },
    mounted() {
        this.loading = true;
        this.$api
            .backendGetAccountProfile()
            .then((result) => {
                console.debug("BACKEND_GET_ACCOUNT_PROFILE", result);
                this.shop = result.shop;
                this.agent = result.agent;
                this.shop.visualizzaIndirizzo =
                    result.shop.visualizzaIndirizzo === "1";
                this.logoUrl = this.shop.urlGrafica
                    ? this.shop.urlGrafica + "?t=" + Date.now()
                    : "";
                if (!this.isAgent) {
                    this.isMapReady = true;
                    this.shop.isShop = true;
                    this.$api
                        .backendGetItalyProvinces()
                        .then((result) => {
                            console.debug("GET_ITALY_PROVINCES", result);
                            this.provincesList = result.provinces;
                            this.onChangeProvince();
                        })
                        .catch((error) => {
                            console.error("GET_ITALY_PROVINCES", error);
                            alert(
                                "Si è verificato un errore. Riprovare più tardi."
                            );
                        });
                }
            })
            .catch((error) => {
                console.error("BACKEND_GET_ACCOUNT_PROFILE", error);
            })
            .finally(() => {
                this.loading = false;
            });
        extend("required", {
            ...required,
            message: this.$t("Campo obbligatorio")
        });
        extend("email", {
            ...email,
            message: this.$t("Inserire una e-mail valida")
        });
    },
    computed: {
        isAgent() {
            var userDataBE = this.$store.getters.userDataBE;
            var isAgent = this.$store.getters.isAgent;
            console.debug("USERDATABE", userDataBE);
            return userDataBE && isAgent;
        }
    }
};
</script>

<style scoped>
.loading {
    position: absolute;
    top: 50%;
    left: calc(50% - 41px);
}
</style>
